import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const LeftMenu = ({ currentPage }) => (
  <div className="col-md-5 col-lg-4 mb-4">
    <aside className="im-left-menu">
      <nav className="im-content-nav">
        <Link href="/about-us/">
          <a className={`im-content-nav__item ${currentPage === 'iyiMakina' ? 'im-content-nav__item--active' : ''}`}>iyimakina.com Hakkında</a>
        </Link>
        <Link href="/about-us/can-i-trust-iyimakina">
          <a className={`im-content-nav__item ${currentPage === 'can-i-trust-iyimakina' ? 'im-content-nav__item--active' : ''}`}>iyiMakina’ya Güvenebilir Miyim?</a>
        </Link>
        <Link href="/about-us/duru-makina">
          <a className={`im-content-nav__item ${currentPage === 'duruMakina' ? 'im-content-nav__item--active' : ''}`}>
            {/* Duru */}
            {' '}
            Makina
          </a>
        </Link>

      </nav>
    </aside>
  </div>
);

LeftMenu.propTypes = {
  currentPage: PropTypes.string,
};

export default LeftMenu;
